import React, { createContext, FC, useReducer } from 'react'

import { AddressDto, SendPaymentDto } from '@/app/model/payments.model'

export type CheckoutData = {
  provider: string
  clientKey: string
  environment: string
  locale: 'pt_BR' | 'en_US' | 'pt_PT' | 'es_ES'
  payment: SendPaymentDto
  merchantKey?: string
  secureCard?: any
  customer?: any
  billingAddress?: Partial<AddressDto>
}

const initialState: CheckoutData = {
  provider: null,
  locale: 'pt_BR',
  environment: process.env.REACT_APP_ADYEN_ENVIRONMENT || 'test',
  clientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY || '',
  payment: null,
  merchantKey: null,
}

export enum CheckoutActionEnum {
  SetPayment = 'SET_PAYMENT',
  ResetPayment = 'RESET_PAYMENT',
  SetMerchantKey = 'SET_MERCHANT_KEY',
}

type CheckoutAction =
  | { type: 'SET_PAYMENT'; payload: SendPaymentDto }
  | { type: 'RESET_PAYMENT' }
  | { type: 'SET_MERCHANT_KEY'; payload: string }

const checkoutReducer = (state: CheckoutData, action: CheckoutAction) => {
  switch (action.type) {
    case 'SET_PAYMENT':
      return { ...state, payment: action.payload }
    case 'RESET_PAYMENT':
      return { ...state, payment: null }
    case 'SET_MERCHANT_KEY':
      return { ...state, merchantKey: action.payload }
    default:
      return state
  }
}

export const CheckoutContext = createContext<{
  state: CheckoutData
  dispatch: React.Dispatch<CheckoutAction>
}>({
  state: initialState,
  dispatch: () => undefined,
})

export const CheckoutProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(checkoutReducer, initialState)

  return (
    <CheckoutContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </CheckoutContext.Provider>
  )
}

export default CheckoutContext
